module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/news/no-bull/"},"frontmatter":{"title":"NO BULL","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1200x1200-no-bull-social-square-v1-0095e707948f09f368e84df9438c0536.jpg"}}},"original":"/img/1200x1200-no-bull-social-square-v1.jpg"},"category":"Culture"}}}]}},"pathContext":{"tag":"VW"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-vw.json
// module id = 1829
// module chunks = 60452842642289